import { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';


interface Props {
  onClose: () => void;
}

const UserOnboardingPopup = ({ onClose }: Props) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!auth.currentUser) return;
    setLoading(true);

    const userData = {
      id: auth.currentUser.uid,
      firstName,
      lastName,
      email: auth.currentUser.email || '',
      phone,
      role: 'participant',
      createdAt: new Date(),
    };

    await setDoc(doc(db, 'users', auth.currentUser.uid), userData);
    setLoading(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-lg w-96 flex flex-col gap-4"
      >
        <h2 className="text-lg font-semibold mb-2">Complétez votre profil</h2>

        <input
          type="text"
          placeholder="Prénom"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
          className="border px-3 py-2 rounded"
        />

        <input
          type="text"
          placeholder="Nom"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
          className="border px-3 py-2 rounded"
        />

        <input
          type="tel"
          placeholder="Téléphone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="border px-3 py-2 rounded"
        />

        <button
          type="submit"
          disabled={loading}
          className="bg-[#623413] text-white py-2 rounded hover:bg-[#4e2910] transition-colors"
        >
          {loading ? 'Enregistrement...' : 'Enregistrer'}
        </button>
      </form>
    </div>
  );
};

export default UserOnboardingPopup;
